import React, { useState, useEffect } from 'react';

/**
 * F18: Non-blocking banner when the device is offline (limited mode).
 */
export default function OfflineBanner({ enabled, onRetry }) {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [lastOfflineAt, setLastOfflineAt] = useState(null);
  const [justReconnected, setJustReconnected] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;

    const sync = () => {
      const isOnline = navigator.onLine;
      if (!isOnline) {
        setLastOfflineAt(new Date());
        setJustReconnected(false);
      } else if (!online) {
        setJustReconnected(true);
        setTimeout(() => setJustReconnected(false), 4000);
      }
      setOnline(isOnline);
    };
    window.addEventListener('online', sync);
    window.addEventListener('offline', sync);
    return () => {
      window.removeEventListener('online', sync);
      window.removeEventListener('offline', sync);
    };
  }, [enabled]);

  if (!enabled) return null;

  if (online && !justReconnected) return null;

  const offlineTimeLabel = lastOfflineAt
    ? lastOfflineAt.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <div
      role="status"
      className={`sticky top-0 z-40 w-full border-b px-4 py-2 text-center text-sm ${
        online
          ? 'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-700 dark:bg-emerald-950/90 dark:text-emerald-100'
          : 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-700 dark:bg-amber-950/90 dark:text-amber-100'
      }`}
    >
      {online ? (
        <span className="font-medium">Koneksi kembali normal.</span>
      ) : (
        <>
          <span className="font-medium">Anda sedang offline.</span>{' '}
          Beberapa fitur membutuhkan koneksi internet.
          {offlineTimeLabel ? ` (sejak ${offlineTimeLabel})` : ''}
        </>
      )}
      {!online && (
        <button
          type="button"
          onClick={onRetry || (() => window.location.reload())}
          className="ml-3 rounded-md border border-amber-300 px-2 py-1 text-xs font-medium hover:bg-amber-100 dark:border-amber-600 dark:hover:bg-amber-900/40"
        >
          Coba lagi
        </button>
      )}
    </div>
  );
}
